import { StepHeader } from "@/components/StepHeader";
import { StepLayout } from "./StepLayout";
import { Button } from "@/components/ui/button";
import { baseCategories } from "@/data/dosingData";

interface PatientWeightProps {
  selectedRegion: string;
  onWeightSelect: (weightCategory: string) => void;
}

export const PatientWeight = ({
  selectedRegion,
  onWeightSelect,
}: PatientWeightProps) => {
  // Weight categories - add extra option for Saudi Arabia (KSA)
  const getWeightCategories = () => {
    // Add extra weight category for Saudi Arabia
    if (selectedRegion.toLowerCase() === "ksa") {
      return [
        { label: "≥ 5 to < 10 kg", value: "5-10" },
        ...baseCategories.map((cat) => ({ ...cat, selected: false })), // Remove default selection when KSA
      ];
    }

    return baseCategories;
  };

  const weightCategories = getWeightCategories();

  return (
    <StepLayout
      currentStep={3}
      showImportantNote={true}
      showReference={true}
      selectedRegion={selectedRegion}
    >
      <div className="mx-auto max-w-4xl text-center">
        {/* Weight Icon */}
        <StepHeader
          title="Select Patient's Weight"
          subTitle="Select the appropriate weight category to proceed with dosing instructions"
          image="/images/icons/select-patient-weight.svg"
        />

        {/* Weight Categories Grid */}
        <div className="mt-8 grid max-w-4xl grid-cols-2 flex-wrap justify-center gap-6 sm:flex">
          {weightCategories.map((category) => (
            <Button
              key={category.value}
              onClick={() => onWeightSelect(category.value)}
              className="rounded-[50px] border-2 border-transparent bg-white font-semibold text-gray-700 shadow-md transition-all duration-300 hover:border-2 hover:border-teal-700 hover:bg-teal-50 sm:w-[200px] sm:p-6 sm:py-8 sm:text-lg"
            >
              {category.label}
            </Button>
          ))}
        </div>
      </div>
    </StepLayout>
  );
};
